import { useData } from 'context/data.context';
import { CaretRightIcon } from "@phosphor-icons/react";

const UpdatesCard = ({ onClick }) => {
  const { networthCurrent } = useData();
  const totalCount = networthCurrent.assets.count + networthCurrent.liabilities.count;
  const needsUpdate = networthCurrent.assets.needs_update + networthCurrent.liabilities.needs_update;

  return (
    <div className="card r4-3 flex col space pointer" onClick={onClick}>
      <div className="flex row space">
        <div>
          <p className="large">Updates</p>
          <p className="regular o60">Due</p>
        </div>
        <p className="large"><CaretRightIcon /></p>
      </div>
            <p className="number xxxlarge ">{needsUpdate}</p>
    </div>
  );
};

export default UpdatesCard;
